import React, { useState } from 'react';
import finalLogo from '../../assets/images/final-logo.svg';
import Button from '../../components/shared/Button';
import questionIcon from "../../assets/icons/question.svg"
import Modal from '../../components/modals/modal';
import emailSentSuccess from "../../assets/icons/emailSentSuccess.svg"
import { useNavigate } from "react-router-dom";


const styles = {
	section: 'flex items-center justify-center min-h-screen bg-bgColor',
	imageStyle: 'h-12 w-[260px] mb-20',
	mainHeading: 'text-left text-main leading-39 font-semibold text-dark-blue mb-3',
	subHeading: 'text-left text-lg leading-100 text-gray mb-[50px] font-medium',
	emailLabel: 'block text-base leading-100 font-medium text-dark-blue  text-left',
	emailInput: 'w-full pl-3.5 py-3.5 border-1p3 mt-3 border-lightGrey rounded-10p placeholder-gray-400'
};

const AdminForgotPasswordPage = () => {
	const [email, setEmail] = useState('');
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const navigate = useNavigate();



	const handleSubmit = (e) => {
		e.preventDefault();
		// Call API for admin forgot password
        setIsSuccessModalOpen(true);
	};

	return (
		<div className={styles.section}>
			<div className="w-full max-w-md lg:w-[520px] lg:h-[645px] flex flex-col justify-center">
				<div>
					<img className={styles.imageStyle} src={finalLogo} alt="WriteForm Logo" />
					<h2 className={styles.mainHeading}>Forgot your password?</h2>
					<p className={styles.subHeading}>Forgot your password no worries</p>
				</div>
				<form className="" onSubmit={handleSubmit}>
					<div className="mb-[60px]">
                        <div className="flex items-center gap-2 mb-2">
                            <label htmlFor="email-address" className={styles.emailLabel}>
                                Email address
                            </label>
                            <img src={questionIcon} alt="help icon" className="w-4 h-4" />
                        </div>

						<input
							id="email-address"
							name="email"
							type="email"
							autoComplete="email"
							required
							className={styles.emailInput}
							placeholder="Enter email address"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
						/>
					</div>

					<div>
						<Button type="submit">Send email</Button>
					</div>
				</form>
			</div>

            {/* Success Modal */}
            <Modal
				isOpen={isSuccessModalOpen}
				onClose={() => setIsSuccessModalOpen(false)}
				icon={<img src={emailSentSuccess} alt="Email Sent Success" className="mx-auto" />}
				heading="Email sent successfully"
				description="We have sent you reset password instruction on your email."
				buttonText="Got it"
				onButtonClick={() => {
                    setIsSuccessModalOpen(false)
                    navigate("/admin/new-password")
                }}
			/>
		</div>
	);
};

export default AdminForgotPasswordPage;
